module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("5XAWp"))).then(() => parcelRequire('3SFNp'));